import {Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Home} from './Home';
import {DomSanitizer} from '@angular/platform-browser';
import {Globals} from '../globals';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  // mySlideOptions={items:1, dots: true, nav: true , loop: true , arrows:true };
  // myCarouselOptions={items: 3, dots: true, nav: true};
  ans = true;
  slider = new Array();
  home: Home;
  config: any = {
    //  effect:'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    speed: 1000,
    loop: true,

    zoomToggle: false,
    setWrapperSize: true,

  };

  config2: any = {
    effect: 'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined
    breakpoints: {
      900: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: true,

    zoomToggle: false,
    setWrapperSize: true,

  };
  config1: any = {
    //  effect:'fade',
    autoplay: false, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 3, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: true,

    zoomToggle: false,
    setWrapperSize: true,

  };

  constructor(
    private http: HttpClient,
    public globals: Globals,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private router: Router
  ) {


  }

  ngOnInit() {

    if (localStorage.getItem('lang')) {
      this.router.navigate([localStorage.getItem('lang')]);
    } else {
      this.router.navigate(['hy']);
    }
    localStorage.setItem('headerImage', '../../assets/img/header.png');
    $(window).scrollTop(0);


    // this.changeIframes();
    // this.changeAsparLink() ;


    this.http.get<Home>(this.globals.urlMain + 'home').subscribe(data => {
        this.home = data;
        this.slider.push(data);
        //   for (let i = 0; i < this.home.aspar.radio_aspar_galery.length; i++) {
        //     this.home.aspar.radio_aspar_galery[i].file = this.home.paths.aspar_rep_path + this.home.aspar.radio_aspar_galery[i].file;
        //   }
        // this.home.aspar.file = this.home.paths.aspar_glxavor_path + this.home.aspar.file;
        // console.log(this.slider)
      }
    );

  }


  iframeSet(event) {
    console.log('***************************************event***********************************');
    console.log(event);
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    // var value = idAttr.nodeValue;

    var id = $(target).attr('data-id');
    var _this = $(target);
    var newImgsrc = _this.parent().parent().parent().find('.largePic').find('img').attr('src');
    var newVideo = _this.parent().parent().parent().find('.largePic').find('iframe').attr('src');
    var title_zinuj = _this.parent().parent().parent().find('.largePic').find('.title_zinuj').html();
    var new_title_zinuj = _this.data('title');
    var newsrc = $(target).closest('.zinujPageSmalls').find('img').attr('data-id');
    _this.parent().parent().parent().find('.largePic').find('.title_zinuj').html(new_title_zinuj);
    _this.data('title', title_zinuj);

    var iframe = document.createElement('iframe');
    iframe.src = newsrc;
    iframe.height = '100%';
    iframe.width = '100%';
    _this.parent().parent().parent().find('.largePic').find('img').attr('src', $(target).closest('.zinujPageSmalls').find('img').attr('src'));
    var oldIframe = document.createElement('img');
    oldIframe.src = newImgsrc;
    oldIframe.setAttribute('data-id', newVideo);
    oldIframe.style.height = '100%';
    oldIframe.style.width = '100%';
    // $(target).closest('.smallZinuj').remove();
    $('#' + id).find('img').remove();
    $('#' + id).prepend(oldIframe);
    $('#' + id).append($(target));

    $('.largePic.zinuj ').find('iframe').remove();
    $('.largePic.zinuj').prepend(iframe);
  }

  openModal(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }

  changeVideo(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    // var value = idAttr.nodeValue;

    var id = $(target).attr('data-id');
    var newImgsrc = $('.iframe.aspar').find('img').attr('src');
    var newVideo = $('.iframe.aspar').find('iframe').attr('src');
    var newsrc = $(target).closest('.zinujPageSmalls').find('img').attr('data-id');

    var iframe = document.createElement('iframe');
    iframe.src = newsrc;
    iframe.height = '100%';
    iframe.width = '100%';
    $('.iframe.aspar').find('img').attr('src', $(target).closest('.zinujPageSmalls').find('img').attr('src'));
    var oldIframe = document.createElement('img');
    oldIframe.src = newImgsrc;
    oldIframe.setAttribute('data-id', newVideo);
    oldIframe.style.height = '100%';
    oldIframe.style.width = '100%';
    // $(target).closest('.smallZinuj').remove();
    $('#' + id).find('img').remove();
    $('#' + id).prepend(oldIframe);
    // $('#'+id).append( $(target));

    $('.iframe.aspar ').find('iframe').remove();
    $('.iframe.aspar').prepend(iframe);
  }

  changeAudio(index) {
    const item = this.home.aspar.aspar_reportajner[index];

    // @ts-ignore
    this.home.aspar.aspar_reportajner[index] = this.home.aspar.aspar_glxavor;

    // @ts-ignore
    this.home.aspar.aspar_glxavor = item;
  }
}


